import { render, staticRenderFns } from "./QueryLionS.vue?vue&type=template&id=522d5d3b&"
import script from "./QueryLionS.vue?vue&type=script&lang=js&"
export * from "./QueryLionS.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports